module.exports = __webpack_public_path__ + "img/h.b26605c6.jpg";